import Squire from 'squire-rte';

const proto = Squire.prototype;

proto.makeHeader = function makeHeader(heading) {
  return this.modifyBlocks(frag => {
    const output = document.createDocumentFragment();
    let block = frag;
    block = Squire.getNextBlock(block);
    while (block) {
      output.appendChild(this.createElement(heading, [Squire.empty(block)]));
      block = Squire.getNextBlock(block);
    }
    return output;
  });
};

proto.makeParagraph = function makeParagraph() {
  return this.modifyBlocks(frag => {
    const output = document.createDocumentFragment();
    let block = frag;
    block = Squire.getNextBlock(block);
    while (block) {
      output.appendChild(this.createElement('p', [Squire.empty(block)]));
      block = Squire.getNextBlock(block);
    }
    return output;
  });
};

proto.isEmpty = function isEmpty() {
  const stripedHtml = this.getHTML().replace(/<(.|\n)*?>/g, '');
  return stripedHtml === '';
};

proto.bold = command('changeFormat', { tag: 'strong' });
proto.italic = command('changeFormat', { tag: 'em' });
proto.removeBold = command('changeFormat', null, { tag: 'strong' });
proto.removeItalic = command('changeFormat', null, { tag: 'em' });
proto.getTextAlignment = function getAlignment() {
  let alignment;

  this.forEachBlock(block => {
    const className = block.style.textAlign;
    if (className !== '') {
      alignment = className;
    }
  }, true);

  return alignment;
};

export default Squire;

function command(method, arg, arg2) {
  return function cmd() {
    this[method](arg, arg2);
    return this.focus();
  };
}
